import "./bootstrap";
import "../css/app.css";
// import 'inertiaui/table/dist/style.css'

import { createApp, DefineComponent } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";

const appName = import.meta.env.VITE_APP_NAME || "Laravel";
import { renderApp, Modal, ModalLink } from "@inertiaui/modal-vue";

import Toast, { PluginOptions, POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";

const options: PluginOptions = {
    // You can set your default options here
    timeout: 3000,
    position: POSITION.TOP_RIGHT,
};

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob<DefineComponent>("./Pages/**/*.vue"),
        ),
    setup({ el, App, props, plugin }) {
        createApp({ render: renderApp(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(Toast, options)
            .component("Modal", Modal)
            .component("ModalLink", ModalLink)
            .mount(el);
    },
    progress: {
        color: "#2c76b5",
    },
});
